import { graphql } from '@apollo/client/react/hoc';

import SampleFeedQuery from 'buyside/graphql/queries/SampleFeed';

import SampleFeedItemsPanel from 'buyside/components/presentation/Feed/SampleFeedItemsPanel/sampleFeedItemsPanel';

const SampleFeedItemsPanelContainer = graphql(SampleFeedQuery, {
  props({ data: { loading, sampleFeedItems } }) {
    return {
      loading,
      sampleFeedItems
    };
  }
})(SampleFeedItemsPanel);

export default SampleFeedItemsPanelContainer;
